import {
  // eslint-disable-next-line camelcase
  legacy_createStore,
  applyMiddleware,
  AnyAction,
  combineReducers,
} from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import thunk, { ThunkDispatch, ThunkAction } from 'redux-thunk';
import authReducer from './modules/Authorization/auth';
import { favoritesReducer } from './modules/Favorites';
import locationReducer from './modules/Location/location';
import discountsReducer from './modules/Discounts/discounts';
import categoriesReducer from './modules/Categories/categories';
import discountEditorReducer from './modules/DiscountEditor/discountEditor';
import alertReducer from './modules/Alert/alert';
import { middlewareForLocalStorage } from './middlewares/localStorage';
import { discountEditorToLocalStorage } from './middlewares/discountEditor.localStorage';
import discountRequestReducer from './modules/DiscountRequest/discountRequest';
import notificationsReducer from './modules/Notifications/notifications';
import { archivedDiscountsReducer } from './modules/ArchivedDiscounts';
import topDiscountReducer from './modules/TopDiscounts/topDiscounts';
import topUserReducer from './modules/TopUsers/topUsers';

const rootReducer = combineReducers({
  auth: authReducer,
  favorites: favoritesReducer,
  location: locationReducer,
  discounts: discountsReducer,
  categories: categoriesReducer,
  discountRequest: discountRequestReducer,
  discountEditor: discountEditorReducer,
  alert: alertReducer,
  notifications: notificationsReducer,
  archivedDiscounts: archivedDiscountsReducer,
  topDiscounts: topDiscountReducer,
  topUsers: topUserReducer,
});

export const store = legacy_createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      thunk,
      middlewareForLocalStorage,
      discountEditorToLocalStorage,
    ),
  ),
);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch &
  ThunkDispatch<RootState, unknown, AnyAction>;
export type AppThunkAction<ReturnType = Promise<void>> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;
